import { render, staticRenderFns } from "./GridVodStatusIndicator.vue?vue&type=template&id=681bb53d&scoped=true&"
import script from "./GridVodStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./GridVodStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681bb53d",
  null
  
)

export default component.exports